module.exports = __webpack_public_path__ + "static/media/icon-facebook.3619245b.svg";